import React, { useEffect, useState } from "react";
import { CollaboratorProfileCard } from "../CollaboratorProfileCard";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import {
  ACHIEVING_GOALS_LABEL,
  COMPARISON_OBJECTIVE_LABEL,
  EMPTY_STRING,
} from "../../../constants/Dictionary";
import { BodyTyp, TitlesTyp } from "../../Typography/Typography";
import { Select, SelectVariantEnum } from "../../core/Select/Select";
import { InputSizes } from "../../core/Input/Input";
import { IconManager } from "../../core/IconManager/IconManager";
import { theme } from "../../../constants/StyledComponents";
import { ReactComponent as TargetIcon } from "../../../icons/target.svg";
import { ReactComponent as ArrowDownIcon } from "../../../icons/arrowDown.svg";
import { StyledRotateSvg } from "../CollaboratorProfileCard.styled";
import { CollaboratorAchievement } from "../../../types/api/collaborators.type";

type GoalsCardProps = {
  achievement: CollaboratorAchievement[];
};

export const GoalsCard = ({ achievement }: GoalsCardProps) => {
  const [selectedAchievement, setSelectedAchievement] =
    useState<CollaboratorAchievement | null>(null);

  const percentageGoal: number | null =
    selectedAchievement !== undefined && selectedAchievement !== null
      ? selectedAchievement.percentageGoal
      : null;
  const percentualTrend: number | null =
    selectedAchievement !== undefined && selectedAchievement !== null
      ? selectedAchievement.percentualTrend
      : null;

  const isTrendNegative: boolean = percentualTrend
    ? percentualTrend <= 0
    : false;

  const onChangeYear = (value: number | null) => {
    if (value) {
      const selected = achievement.find((item) => item.year === value);
      if (selected) {
        setSelectedAchievement(selected);
      }
    }
  };

  useEffect(() => {
    if (achievement.length > 0) {
      setSelectedAchievement(achievement[0]);
    }
  }, [achievement]);

  return (
    <CollaboratorProfileCard
      content={
        <>
          <div className="card-header">
            <TitlesTyp fontWeight={FontWeightEnum.SEMIBOLD} variant="3">
              {ACHIEVING_GOALS_LABEL}
            </TitlesTyp>
            <Select
              variant={SelectVariantEnum.DEFAULT}
              onChange={onChangeYear}
              size={InputSizes.SMALL}
              options={achievement.map((items) => ({
                value: items.year,
                label: items.year.toString(),
              }))}
              value={selectedAchievement?.year}
              allowClear={false}
            />
          </div>

          <div className="card-row">
            <IconManager size={IconSizeEnum.LARGE} color={theme.colors.purple}>
              <TargetIcon />
            </IconManager>
            <TitlesTyp fontWeight={FontWeightEnum.SEMIBOLD} variant="1">
              {percentageGoal ?? EMPTY_STRING}%
            </TitlesTyp>
          </div>
        </>
      }
      {...(percentualTrend !== null && {
        bottomContent: (
          <div className="card-row">
            <StyledRotateSvg $isNegative={isTrendNegative}>
              <ArrowDownIcon />
            </StyledRotateSvg>
            <BodyTyp fontWeight={FontWeightEnum.REGULAR} variant="3">
              {`${percentualTrend}% ${COMPARISON_OBJECTIVE_LABEL}`}
            </BodyTyp>
          </div>
        ),
      })}
    />
  );
};
